import { z } from "zod";

import { apiGet } from "../lib/api";

export const AuditOutcomeSchema = z.enum([
  "pass",
  "violation",
  "safe_utterance_substitution",
  "opening_greeting",
  "recording_disclosure",
  "recording_started",
  "recording_stopped",
  "recording_failed",
  "recording_accessed",
  "sip_outbound_initiated",
  "sip_outbound_failed",
  "voice_cloned",
  "post_hoc_violation_hangup",
  "evidence_tool_invoked",
  "evidence_tool_blocked_out_of_scope",
  "max_turns_reached_hangup",
  "agent_initiated_hangup",
]);
export type AuditOutcome = z.infer<typeof AuditOutcomeSchema>;

export const AuditEntryRowSchema = z.object({
  index: z.number(),
  timestamp: z.string(),
  action_id: z.string().uuid(),
  engagement_id: z.string().uuid(),
  outcome: AuditOutcomeSchema,
  violation_code: z.string().nullable().optional(),
  violation_reason: z.string().nullable().optional(),
  replaces_action_id: z.string().uuid().nullable().optional(),
  call_id: z.string().uuid().nullable().optional(),
  prev_hash: z.string(),
  entry_hash: z.string(),
});
export type AuditEntryRow = z.infer<typeof AuditEntryRowSchema>;

export const AuditListResponseSchema = z.object({
  items: z.array(AuditEntryRowSchema),
  total: z.number(),
  head_hash: z.string(),
});
export type AuditListResponse = z.infer<typeof AuditListResponseSchema>;

export function fetchAudit(limit: number = 200) {
  return apiGet(`/api/audit?limit=${limit}`, AuditListResponseSchema);
}
